export * from './golden-duel-promo-modal';